import { useState, useEffect } from "react";
import styles from "./ToggleSwitch.module.scss";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import wrapperHOC from "@Utils/wrapperHOC";

interface IProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  ariaLabel?: string;
}

const ToggleSwitch = ({
  checked = false,
  onChange,
  disabled = false,
  className = "",
  ariaLabel = "Toggle",
}: IProps) => {
  const [isChecked, setIsChecked] = useState(checked);

  // Sync internal state with prop changes
  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  const handleToggle = () => {
    if (disabled) return;
    const newChecked = !isChecked;
    setIsChecked(newChecked);
    if (onChange) {
      onChange(newChecked);
    }
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isChecked}
      aria-label={ariaLabel}
      className={formatClassNames(
        styles.toggle,
        isChecked && styles.checked,
        disabled && styles.disabled,
        className,
      )}
      onClick={handleToggle}
      disabled={disabled}
    >
      <span className={styles.slider} />
    </button>
  );
};

export default wrapperHOC(ToggleSwitch, {
  componentName: "ToggleSwitch",
  showForChina: true,
});
